export const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const propertyOf = (value: unknown, key: string): unknown => (isRecord(value) ? value[key] : undefined);
